<!--  -->
<template>
  <div>
    <div
      class="amall-title flex justify-start align-center text-black"
      :class="level == 1 ? 'first-level text-bold text-20' : 'text-14'"
    >
      <div class="padding-6" v-for="(item, index) of title" :key="index">
        <div
          v-if="index == 0"
          :class="title.length == 2 ? 'amall-text-greys l-hand-change' : ''"
          @click="back"
        >
          {{ item }}
        </div>
        <div v-else>> {{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    title: {
      type: Array, //指定传入的类型
      default: () => [], //这样可以指定默认的值
    },
  },
  data() {
    return {
      level: 1,
    };
  },
  created() {
    this.level = this.title.length;
  },
  methods: {
    back() { 
      if (this.title.length == 2) {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.amall-title {
  height: 75px;
  padding: 0 23px;
  box-sizing: border-box;
  width: 100%;
}
.first-level::before {
    content: " ";
    width: 4px;
    height: 20px;
    background: var(--amall-green);
    opacity: 1;
    border-radius: 0px;
}
.amall-text-greys {
  color: #9e9e9e;
}
</style>


// WEBPACK FOOTER //
// src/components/customTitle/index.vue